<div class="container">
  <rd-shared-icon
    [iconSymbol]="'icon-warning'"
    [iconTheme]="'warn'"></rd-shared-icon>

  <h1 class="title">
    {{ 'redeem_cash_v2.membership_failed_dialog.title' | translate }}
  </h1>

  <p class="description">
    {{ 'redeem_cash_v2.membership_failed_dialog.description' | translate }}
  </p>

  <div class="buttons-wrapper">
    <rd-shared-button
      class="ok-button"
      [buttonClass]="failedLinkedDialogButton.buttonClass"
      [buttonContent]="okButtonContent"
      [buttonTheme]="failedLinkedDialogButton.buttonTheme"
      (clickFn)="closeDialog()">
      <ng-template #okButtonContent>
        <span class="ok-button-text">{{
          failedLinkedDialogButton.buttonText | translate
        }}</span>
      </ng-template>
    </rd-shared-button>
  </div>
</div>
